module.exports = __webpack_public_path__ + "static/media/document-hand-held-writing.3dfd8430.svg";